import React from 'react';

import { IntegrationsSettings } from '@shipstation/connections-ui';
import PropTypes from 'prop-types';

import { noop } from 'ui-components/default-props/noop';

import { useCommonCuiProps } from './helpers/use-common-cui-props';
import { emptyArray } from 'ui-components/default-props/empty';

export const CuiIntegrationsSettings = ({ integrationAppId, onDelete = noop, sellerStores = emptyArray }) => {
  const commonCuiProps = useCommonCuiProps();
  return <IntegrationsSettings {...commonCuiProps} integrationAppId={integrationAppId} onDelete={onDelete} sellerStores={sellerStores} />;
};

CuiIntegrationsSettings.propTypes = {
  integrationAppId: PropTypes.number.isRequired,
  onDelete: PropTypes.func,
  sellerStores: PropTypes.array,
};
